// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Icon } from "semantic-ui-react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const IconOpen = () => /*#__PURE__*/_jsx(Icon, {
  name: "share square",
  link: true,
  "data-sentry-element": "Icon",
  "data-sentry-component": "IconOpen",
  "data-sentry-source-file": "FavoriteActionIcon.tsx"
});
export const IconDelete = () => /*#__PURE__*/_jsxs(Icon.Group, {
  "data-sentry-element": "unknown",
  "data-sentry-component": "IconDelete",
  "data-sentry-source-file": "FavoriteActionIcon.tsx",
  children: [/*#__PURE__*/_jsx(Icon, {
    name: "star",
    color: "orange",
    link: true,
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "FavoriteActionIcon.tsx"
  }), /*#__PURE__*/_jsx(Icon, {
    name: "close",
    color: "red",
    corner: true,
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "FavoriteActionIcon.tsx"
  })]
});
export const IconReorder = () => /*#__PURE__*/_jsx(Icon, {
  name: "arrows alternate vertical",
  "data-sentry-element": "Icon",
  "data-sentry-component": "IconReorder",
  "data-sentry-source-file": "FavoriteActionIcon.tsx"
});